export const PLUGIN_NAME = 'posthog';

// core-auth-ui emits these on login and logout
export const LOGOUT_EVENT = 'package:core-auth-ui:logout';
// emitted by the frontend-shopware guest registration form, with { customerId, email }
export const GUEST_REGISTERED_EVENT = 'plugin:shopware:guest:registered';

// PostHog explicit consent status, see posthog.get_explicit_consent_status()
export const CONSENT_STATUS = {
  GRANTED: 'granted',
  DENIED: 'denied',
  PENDING: 'pending'
};

export const CONSENT_MODES = {
  // Opt in or out from the configured Didomi purposes and vendors
  DIDOMI: 'didomi',
  // Always opt in. For testing only, not for a live site
  ASSUMED: 'assumed',
  // Always opt out: with captureOnReject PostHog captures without cookies, otherwise nothing
  DISABLED: 'disabled'
};

export const DIDOMI_CONSENT_CHANGED_EVENT = 'consent.changed';

// longest time guest registration waits for posthog-js to finish loading before it continues
export const IDENTIFY_WAIT_MS = 3000;

// same cap as the campaign plugin
export const MAX_SESSION_PARAM_LENGTH = 100;

export const DEFAULT_OPTIONS = {
  apiKey: '',
  // first party proxy host, e.g. https://e.example.com, defaults to PostHog EU
  apiHost: 'https://eu.i.posthog.com',
  uiHost: 'https://eu.posthog.com',
  defaults: '2026-05-30',
  // 'identified_only' (profiles only for identified users) or 'always'
  personProfiles: 'identified_only',
  // PostHog's main cookie / storage key and its consent state key
  persistenceName: 'hogp_v',
  consentPersistenceName: 'hogp_c',
  // share the cookie across subdomains, e.g. *.kelsey.co.uk
  crossSubdomainCookie: true,
  debug: false,
  // properties added to every event (posthog.register), e.g. site and brand ids. Set per project
  superProperties: {},
  // url params added to every event in the current PostHog session (posthog.register_for_session)
  // as prefixed properties, e.g. ['offer'] gives campaign_offer. In addition to PostHog's own
  // utm_* capture, which they never overwrite
  sessionParams: [],
  sessionParamsPrefix: 'campaign_',
  // any other posthog-js config, passed through as is. The options above take priority
  config: {},
  // capture without cookies after consent is rejected (cookieless_mode: 'on_reject'). Off by
  // default, so nothing is captured after a rejection unless a site has approval to turn it on
  captureOnReject: false,
  consent: { mode: CONSENT_MODES.DIDOMI, purposes: [], vendors: [] }
};
